import { useEffect, useMemo, useState } from "react";
import Shell from "../../components/Shell";
import api from "../../lib/api";
import { Download } from "lucide-react";

const CATEGORIES = [
    { value: "all", label: "All" },
    { value: "ifu", label: "IFUs" },
    { value: "brochure", label: "Brochures" },
    { value: "protocol", label: "Protocols" },
    { value: "consent", label: "Consent forms" },
    { value: "marketing", label: "Marketing" },
];

export default function Downloads() {
    const [items, setItems] = useState([]);
    const [cat, setCat] = useState("all");
    const [q, setQ] = useState("");

    useEffect(() => {
        api.get("/downloads").then(r => setItems(r.data || [])).catch(() => {});
    }, []);

    const filtered = useMemo(() => {
        let list = items;
        if (cat !== "all") list = list.filter(i => i.category === cat);
        if (q) list = list.filter(i => i.title.toLowerCase().includes(q.toLowerCase()));
        return list;
    }, [items, cat, q]);

    return (
        <Shell variant="clinic">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10 py-10 animate-fade-in">
                <p className="eyebrow mb-2">Resources</p>
                <h1 className="font-heading text-3xl sm:text-4xl font-light tracking-tight mb-2">Download centre</h1>
                <p className="text-sm text-zinc-500 mb-10">Instructions for use, brochures, treatment protocols, consent forms and marketing assets.</p>

                <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-8">
                    <input data-testid="downloads-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search resources" className="input-base sm:max-w-xs" />
                    <div className="flex flex-wrap gap-2">
                        {CATEGORIES.map(c => (
                            <button key={c.value} onClick={() => setCat(c.value)} data-testid={`downloads-cat-${c.value}`} className={`text-xs uppercase tracking-widest px-3 py-2 border rounded-sm transition-colors ${cat === c.value ? "bg-black text-white border-black" : "bg-white text-zinc-600 border-zinc-200 hover:border-black"}`}>{c.label}</button>
                        ))}
                    </div>
                </div>

                {filtered.length === 0 ? (
                    <div className="text-center py-20 border border-dashed border-zinc-200 rounded-sm">
                        <p className="text-sm text-zinc-500">No resources yet — admin will publish documents here.</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="downloads-list">
                        {filtered.map(d => (
                            <a key={d.id} href={`${process.env.REACT_APP_BACKEND_URL}/api/files/${d.file_path}?auth=${localStorage.getItem("derm_token") || ""}`} target="_blank" rel="noreferrer" data-testid={`download-${d.id}`} className="card-base p-5 hover:border-black transition-colors flex items-start justify-between gap-4">
                                <div>
                                    <p className="text-[10px] uppercase tracking-[0.25em] text-zinc-400 mb-1">{d.category}</p>
                                    <p className="font-medium text-sm mb-1">{d.title}</p>
                                    {d.description && <p className="text-xs text-zinc-500">{d.description}</p>}
                                </div>
                                <Download size={18} strokeWidth={1.5} className="text-zinc-500 mt-1 flex-shrink-0" />
                            </a>
                        ))}
                    </div>
                )}
            </div>
        </Shell>
    );
}
